import React, { useEffect, useState } from "react";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import { IHomecareObj, IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import PageHeader from "src/Components/Customer/PageHeader";
import SplashScreen from "src/Components/SplashScreen";
import PaginationComponet from "src/Components/GlobalComponents/PaginationComponet";
import IsFavoriteComponent from "src/Components/Customer/ProductsAndServicesComponents/IsFavoriteComponent";
import { Link, useLocation } from "react-router-dom";
import homecareDetailIcon from "src/assets/images/homecare-detail-icon.png";  
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import AddProductPrescribeModal from "src/Components/DoctorComponents/AddProductPrescribeModal";
import BackIcon from "src/assets/images/back-icon.png";
import { CURRENCY } from "src/lib/constans";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import PriceFilterDropdown from "src/Components/GlobalComponents/Widget/PriceFilterDropdown";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
interface IResponse {
  documents: IHomecareObj[];
  paginated: IPaginated;
}

const DashboardHomecareSerivces: React.FC = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const isPrescribe = urlParams.get("prescribe");
  const appointmentId = urlParams.get("appointmentId");
  const [prescribeProductId, setPrescribeProductId] = useState<null | string>(
    null
  );

  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [products, setProducts] = useState<IHomecareObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination state
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 12,
    userId: userDetails?._id || "",
    categoryIds: ["all"],
    minPrice: 0,
    maxPrice: 1000000,
    search: "",
  });

  const handleIsLikeChanged = (obj: {
    productId: string;
    isLiked: boolean;
  }) => {
    const { productId = "", isLiked = false } = obj;
    setProducts((prev) =>
      prev?.map((v) => (v._id === productId ? { ...v, isLiked } : v))
    );
  };

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IResponse>({
      path: `/home-care-services/home/getallproducts?${qs.stringify(
        {
          ...queryParams,
          categoryIds: queryParams?.categoryIds
          .map((item: string) => (item === "all" ? "" : item))
          .filter((item: string) => item !== "")
        }
      )}`,
    });
    if (res) {
      let { documents = [], paginated } = res;
      setProducts(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetch();
  }, [queryParams]);
  const [categoryStates, setCategoryStates] = useState<{
    allCategories: { value: string; label: string }[];
    loader: boolean;
    searchVal: string;
    isSearch: boolean;
  }>({
    allCategories: [],
    loader: false,
    searchVal: "",
    isSearch: false,
  });

  useEffect(() => {
    (async () => {
      setCategoryStates((prev) => ({ ...prev, loader: true }));
      const { res, err } = await httpRequest<
        { _id: string; categoryName: string }[]
      >({ path: "/homecare-category/all" });
      if (res) {
        const data = (res || [])?.map((v) => ({
          label: v?.categoryName,
          value: v?._id,
        }));
        setCategoryStates((prev) => ({ ...prev, allCategories: [
          {
            value: "all",
            label: "All",
          },
          ...data,
        ] }));
      } else {
        toast(err, { type: "error" });
      }
      setCategoryStates((prev) => ({ ...prev, loader: false }));
    })();
  }, []);

  const BackButton: React.FC = () => {
    return (
      <Link
        to={`/doctor/appointment/${appointmentId}/prescribe`}
        className="right-bar-icon"
      >
        <img src={BackIcon} alt="back-icon" />
      </Link>
    );
  }; // display back icon in page header
  return (
    <>
      <AddProductPrescribeModal
        appointmentId={appointmentId}
        productId={prescribeProductId}
        productName={
          products?.find((v) => v._id === prescribeProductId)?.serviceName || ""
        }
        type="homecare"
        show={prescribeProductId ? true : false}
        onClose={() => setPrescribeProductId(null)}
      />
      <div className="view-area-width-2 h-3vw">
        <PageHeader
          title="All Services"
          marginBottom={false}
          {...(isPrescribe
            ? { isButton: true, ButtonComponent: BackButton }
            : {})}
        />
        {isLoader && <SplashScreen />}
        <div className="dasboard-new-filter">
          <div
            id={"pharma-dasboard-bg-tem-height"}
            className="pharma-dasboard-bg-tem"
          >
            <div className="flex w-full justify-between items-center gap-2 mt-3.5">
              <div className="flex items-center gap-2 flex-1 w-fit">
                <CustomWebsiteDropdown
                  options={categoryStates?.allCategories}
                  setData={(data) => {
                    if (data.length > 0) {
                      setQueryParams((prev) => ({
                      ...prev,
                        categoryIds: data?.map((v) => v?.value),
                      }));
                    } else {
                      setQueryParams((prev) => ({
                        ...prev,
                        categoryIds: ["all"],
                      }));
                    }
                  }}
                  data={
                    categoryStates?.allCategories?.filter((v) =>
                      queryParams?.categoryIds?.includes(v?.value)
                    ) || [{
                      value: "all",
                      label: "All",
                    }]
                  }
                  placeholder="Filter by Category"
                  withoutMargin
                  loading={categoryStates?.loader}
                  mainDivClass="min-w-[130px] lg:min-w-[12vw] !w-fit"
                  showRadioBtn
                />
                <PriceFilterDropdown
                  setData={(data) => {
                    if (data) {
                      setQueryParams((prev) => ({
                        ...prev,
                        minPrice: data?.min || "",
                        maxPrice: data?.max || "",
                      }));
                    } else {
                      setQueryParams((prev) => ({
                        ...prev,
                        minPrice: "",
                        maxPrice: "",
                      }));
                    }
                  }}
                  data={
                    queryParams?.minPrice !== "" || queryParams?.maxPrice !== ""
                      ? {
                          min: queryParams?.minPrice,
                          max: queryParams?.maxPrice,
                        }
                      : null
                  }
                  placeholder="Filter by Price"
                  withoutMargin
                  mainDivClass="min-w-[130px] lg:min-w-[12vw] !w-fit"
                />
              </div>
              <div>
                <SearchFilterInput
                  placeHolder="Search for Products"
                  searchVal={queryParams?.search || ""}
                  onChangeText={(val) =>
                    setQueryParams((prev) => ({
                      ...prev,
                      search: val || "",
                    }))
                  }
                  inputExtraStyle={{
                    marginBottom: "0",
                  }}
                />
              </div>
            </div>
            <hr className="my-3 xs:my-4 products-tabs-hr-allOrder" />
            <div
              key={`${Math.random()}${queryParams?.categoryIds?.length}`}
              className="diagnostic-products-grid"
            >
              {products.map((item) => (
                <div key={item?._id} className="pharmacy-card-main">
                  <div className="Prescription-requird-main">
                    {/* <div className="Prescription-requird">
                      {item?.prescriptionRequired ? (
                        <span className="Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px">
                          Prescription Required
                        </span>
                      ) : (
                        <span></span>
                      )}
                      {!isPrescribe && (
                        <IsFavoriteComponent
                          productId={item?._id}
                          isFav={item?.isLiked || false}
                          category="homecare"
                          onSuccess={handleIsLikeChanged}
                        />
                      )}
                    </div> */}
                  </div>
                  <div className="pharmacy-card-main-content-cls-inner w-full aspect-[1/0.8]">
                    <img
                      className="w-full h-full object-cover"
                      src={`${item?.mainImage}`}
                      alt={""}
                    />
                  </div>
                  <div className="pharmacy-card-main-content-cls min-h-[100px] lg:min-h-[8vw] flex flex-col justify-between">
                    {isPrescribe ? (
                      <span>
                        <p className="font-size-18px font-Poppins-SemiBold line-clamp-2 theme-color-green">
                          {item?.serviceName}
                        </p>
                      </span>
                    ) : (
                      <Link to={`/doctor/homecareservices/${item?._id}/view`}>
                        <p className="font-size-18px font-Poppins-SemiBold line-clamp-2 pharmacy-card-main-span-title theme-color-green">
                          {item?.serviceName}
                        </p>
                      </Link>
                    )}
                    <div className="flex product-item-card-price justify-between">
                      <span className="font-size-22px font-Poppins-Bold theme-color-green">{`${CURRENCY} ${
                        parseFloat(item?.price || "0").toLocaleString() || "-"
                      }`}</span>
                      {isPrescribe ? (
                        <button
                          onClick={() => setPrescribeProductId(item?._id)}
                          className="add-to-cart-products"
                        >
                          <FontAwesomeIcon
                            size="sm"
                            className="text-white"
                            icon={faPlus}
                          />
                        </button>
                      ) : (
                        <Link to={`/doctor/homecareservices/${item?._id}/view`}>
                          <img src={homecareDetailIcon} className="w-[2vw]" />
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <PaginationComponet
              currentPage={paginated.currentPage || 1}
              total={paginated.totalPages || 1}
              setCurrentPage={(_page) =>
                setQueryParams((prev) => ({ ...prev, page: _page }))
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardHomecareSerivces;
